import { render } from "./traCourseList.vue?vue&type=template&id=e4d596c8&scoped=true"
import script from "./traCourseList.vue?vue&type=script&lang=js"
export * from "./traCourseList.vue?vue&type=script&lang=js"

import "./traCourseList.vue?vue&type=style&index=0&id=e4d596c8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d596c8"]])

export default __exports__